module.exports = __webpack_public_path__ + "img/HamochiResult2.3aa90eda.png";